import React from 'react'

import { TextField ,Grid, Typography} from "@mui/material"
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import BooleanFilter from '../../core/form/BooleanFilter';
import { useSelector, useDispatch } from 'react-redux';
import { setPartyFilterCriteria } from 'store/slice/PharmaSlice';

export default function PartyFilterCriteria() {
    const dispatch = useDispatch();
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.partyDashboard);
        
    const {partystatusList} = useSelector((state)=>state.pharmaslice);
    
const updateTitleCriteria = (title) =>{
        dispatch(setPartyFilterCriteria(
            {
                ...filterCriteria,
                title:title
        }))
    }
const updateContactCriteria = (contact) =>{
        dispatch(setPartyFilterCriteria(
            {
                ...filterCriteria,
                contact:contact
        }))
    }
const updateContactmobileCriteria = (contactmobile) =>{
        dispatch(setPartyFilterCriteria(
            {
                ...filterCriteria,
                contactmobile:contactmobile
        }))
    }
const updateStatusnameCriteria = (statusname) =>{
        dispatch(setPartyFilterCriteria(
            {
                ...filterCriteria,
                statusname:statusname
        }))
    }
const updateStatusCriteria = (status) =>{
        dispatch(setPartyFilterCriteria(
            {
                ...filterCriteria,
                status:status
        }))
    }

    return (

        <Grid container direction="row" lg={12} sx={{justifyContent:'center'}}>
                    <Grid item lg={4} padding={1}>
                        <TextField type="search" variant="standard"
                            label="Party Name"
                            name="title"
                            value={filterCriteria.title}
                            onChange={(e)=>updateTitleCriteria(e.target.value)}
                            sx={{minWidth:'100px'}}
                        />
                    </Grid>

                    {/* <Grid item lg={4} padding={1}>
                        <TextField type="search" variant="standard"
                            label="Contact"
                            name="contact"
                            value={filterCriteria.contact}
                            onChange={(e)=>updateContactCriteria(e.target.value)}
                            sx={{minWidth:'100px'}}
                        />
                    </Grid>

                    <Grid item lg={4} padding={1}>
                        <TextField type="search" variant="standard"
                            label="Contactmobile"
                            name="contactmobile"
                            value={filterCriteria.contactmobile}
                            onChange={(e)=>updateContactmobileCriteria(e.target.value)}
                            sx={{minWidth:'100px'}}
                        />
                    </Grid>

                    <Grid item lg={4} padding={1}>
                        <TextField type="search" variant="standard"
                            label="Statusname"
                            name="statusname"
                            value={filterCriteria.statusname}
                            onChange={(e)=>updateStatusnameCriteria(e.target.value)}
                            sx={{minWidth:'100px'}}
                        />
                    </Grid>

                    <Grid item padding={1}>
                        <BooleanFilter 
                            label="Status"
                            fieldName="status"
                            defaultValue=""
                            setBooleanValue = {updateStatusCriteria}
                            />
                    </Grid> */}


        </Grid>
    )

}